<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Stuart Fox trained as a teacher and has recently retired after 37 years in school. His family keep him very busy travelling the country and supporting their many activities. He still loves sport, and his Napoleonic passion started when he was taken to watch the film <em>Waterloo</em>!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?e6ce9f32